import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function useCantinaCategorias() {
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    setCargando(true);
    setError('');

    try {
      const response = await api.get('/cantina/categorias');
      setCategorias(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          'No se pudieron cargar las categorías.'
      );
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const crear = async (
    nombre,
    destinoRestaurante = 'COCINA'
  ) => {
    setGuardando(true);
    setError('');

    try {
      await api.post('/cantina/categorias', {
        nombre,
        destino_restaurante: destinoRestaurante,
      });
      await cargar();
      return { ok: true };
    } catch (err) {
      const mensaje =
        err.response?.data?.error ||
        'No se pudo crear la categoría.';

      setError(mensaje);
      return { ok: false, error: mensaje };
    } finally {
      setGuardando(false);
    }
  };

  const editar = async (
    id,
    nombre,
    destinoRestaurante
  ) => {
    setGuardando(true);
    setError('');

    try {
      await api.put(`/cantina/categorias/${id}`, {
        nombre,
        destino_restaurante: destinoRestaurante,
      });
      await cargar();
      return { ok: true };
    } catch (err) {
      const mensaje =
        err.response?.data?.error ||
        'No se pudo editar la categoría.';

      setError(mensaje);
      return { ok: false, error: mensaje };
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    setGuardando(true);
    setError('');

    try {
      await api.delete(`/cantina/categorias/${id}`);
      await cargar();
      return { ok: true };
    } catch (err) {
      const mensaje =
        err.response?.data?.error ||
        'No se pudo eliminar la categoría.';

      setError(mensaje);
      return { ok: false, error: mensaje };
    } finally {
      setGuardando(false);
    }
  };

  return {
    categorias,
    cargando,
    guardando,
    error,
    cargar,
    crear,
    editar,
    eliminar,
  };
}
